<div>
    @if (!field.btnOpts.hide || !field.btnOpts.hide(focusItem)) {
        <!-- Tooltip sits on the span: a disabled button (no tableClickMethod) never shows one -->
        <span [matTooltip]="getToolTip()">
            <button class="row-button" (click)="clickIcon($event,field,focusItem)" mat-icon-button
                [disabled]="!field.btnOpts.tableClickMethod"
                [ngStyle]="field.tableIconStyler(focusItem)">
                @if(!field.tableIconStyler) {
                    <mat-icon color="primary">{{field.getValue(focusItem)}}</mat-icon>
                } @else {
                    <mat-icon>{{field.getValue(focusItem)}}</mat-icon>
                }
            </button>
        </span>
    }
</div>
